import moment from 'moment';

const tConvert = (time: any) => {
  const timeCal = time
    ?.toString()
    .match(/^(0?[0-9]|1[0-9]|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (timeCal?.length > 1) {
    const myMoment = moment(time, 'HH:mm');
    const minutesFormat = myMoment?.format('h:mma');
    if (minutesFormat?.includes('00')) {
      return myMoment?.format('ha');
    }
    return minutesFormat;
  }
  return time?.join('');
};

// eslint-disable-next-line consistent-return
const convertTimeFormat = (value: any, locale: any, text?: string) => {
  if (!value && locale === 'fr') return 'Fermé';
  if (!value) return 'Closed';
  if (value === 'Open 24 hours') {
    return locale === 'en' ? '24 hours' : '24 h/24';
  }
  const trimSpace = value.replace(/\s/g, '');
  const hoursSplit = trimSpace.split('-');

  if (hoursSplit.length !== 2) {
    return value;
  }
  let openTime =
    hoursSplit[0].split(':')[0].length > 1
      ? hoursSplit[0].replace(/^0?/, '')
      : hoursSplit[0];
  let closeTime =
    hoursSplit[1].split(':')[0].length > 1
      ? hoursSplit[1].replace(/^0?/, '')
      : hoursSplit[1];

  // 9 h 18 h
  if (locale === 'fr') {
    if (openTime?.includes(':00')) openTime = openTime?.split(':')[0];
    if (closeTime?.includes(':00')) closeTime = closeTime?.split(':')[0];
    return `${openTime} h à ${closeTime} h`;
  }
  const localeTime = `${tConvert(openTime)} - ${tConvert(closeTime)}`;
  if (text) {
    return `${text} ${localeTime}`;
  }
  return localeTime;
};

export default convertTimeFormat;
